import DocsTooltip from 'components/Common/DocsTooltip';
import React, {useEffect, useState} from 'react'
import {Link} from 'react-router-dom';
import "./style.scss";
import {useDispatch, useSelector} from "react-redux";
import {UncontrolledTooltip} from "reactstrap";
import {getSuggestedMappings} from "../../store/organization/actions";

const SideBar = ({setCurrentTabFromSidebar, current_page = 'Dashboard'}) => {
  const dispatch = useDispatch()
  const navItems = ['Dashboard', 'AlertsList', 'AlcomScoreDashboard', 'AlertAnalytics', 'RecentlyAddedResources', 'MissingAlerts']
  const [tooltip, setTooltip] = useState(false);
  const changeTab = (tab) => {
    setCurrentTabFromSidebar(tab)
  };
  useEffect(() => {
    dispatch(getSuggestedMappings())
  }, [])

  const {suggested_mappings} = useSelector(state => ({
    suggested_mappings: state.Organization.suggested_mappings || [],
  }));

  const [reorderedMappingsCount, setReorderedMappingsCount] = useState(suggested_mappings.length || 0);

  useEffect(() => {
    setReorderedMappingsCount(suggested_mappings.length)
  }, [suggested_mappings.length]);

  return (
    <React.Fragment>
      <div className="sidebar d-none d-md-block">
        {current_page === 'Dashboard' ? (
          <div className='' style={{paddingTop: "30%"}}>
            <ul style={{listStyleType: "none", fontSize: "0.8125rem", marginTop: "10%"}}>
              <li className='mb-2' onClick={() => changeTab('Dashboard')}>
                <i className='bx bx-home me-2'/>
                <span>Dashboard</span>
                <i id='dashTooltip' className='bx bx-help-circle ms-2' style={{position: "relative", top: "1px"}}/>
                <DocsTooltip
                  placement={'right'}
                  isOpen={tooltip}
                  toggle={() => setTooltip(!tooltip)}
                  targetId={'dashTooltip'}
                  linkText={'Control Dashboard'}
                  link={'https://docs.temperstack.com/temperstack/managing-using-temperstack/control-dashboard'}
                />
              </li>
              <li className='mb-2' onClick={() => changeTab('SLO')}>
                <i className='bx bx-stats me-2'/>
                <span>
                SLO Dashboard
              </span>
              </li>
              <li className='mb-2' onClick={() => changeTab('AlcomScoreDashboard')}>
                <i className='mdi mdi-math-compass me-2'/>
                <span>
              Alcom dashboard
              </span>
              </li>
              {/*<li className='mb-2' onClick={() => changeTab('AlertAnalytics')}>*/}
              {/*  <i className='mdi mdi-google-analytics me-2' />*/}
              {/*    <span>*/}
              {/*    Alert analytics*/}
              {/*    </span>*/}
              {/*</li>*/}
              <li className='mb-2' onClick={() => changeTab('MissingAlerts')}>
                <i className='bx bx-bell me-2'/>
                <span>
                Missing Alerts
                </span>
              </li>
              {reorderedMappingsCount > -1 ?
                (
                  <li id="suggestions_generated" className='mb-2' onClick={() => window.location.href = '/organization?tab=5'}>
                    <i className="bx bx-link-external me-2"/>
                    <span>
                      Mapping Suggestions <img src="/icons/ai-compressed.png" alt="Customize Icon" className="me-2 ai-svg-icon"/>
                    </span>
                    <UncontrolledTooltip className="tooltip-component-sidebar" placement="top" target="suggestions_generated">
                      AI generated resource mapping suggestions.
                    </UncontrolledTooltip>
                  </li>
                ) :
                null
              }
              <li className='mb-2'>
                <a rel="noreferrer" className='text-decoration-none' target='_blank'
                   href='https://docs.temperstack.com/temperstack'>
                  <i className='bx bx-help-circle me-1'/>
                  <span>
                  Help and Docs
                </span>
                  <i className='bx bx-link-external ms-1' style={{position: "relative", top: "2px"}}/>
                </a>
              </li>
            </ul>
          </div>
        ) : (current_page === 'AlertList') ? (
          <div style={{paddingTop: "30%"}}>
            <ul style={{listStyleType: "none", fontSize: "0.8125rem", marginTop: "10%"}}>
              <li>
                <i className="bx bx-customize me-2"></i>
                <Link to="/alerts?tab=AlertsList">Alerts List</Link>
              </li>
              <li>
                <i className="mdi mdi-google-analytics me-2"></i>
                <Link to="/alerts?tab=AlertAnalytics">Alerts Analytics</Link>
              </li>
              <li>
                <i className="bx bx-stats me-2"></i>
                <Link to="/alerts?tab=AlertsForOptimization">Alerts Optimization</Link>
              </li>
              <li>
                <i className='mdi mdi-gauge me-2'/>
                <Link to="/alerts?tab=MTTR+MTTA">MTTR MTTA</Link>
              </li>
              <li>
                <i className='dripicons-medical me-2'/>
                <Link to="/daemon">Heal</Link>
              </li>
            </ul>
          </div>
        ) : (current_page === 'Incident Management') ? (
            <div style={{paddingTop: "30%"}}>
              <ul style={{listStyleType: "none", fontSize: "0.8125rem", marginTop: "10%"}}>
                <li>
                  <i className="bx bx-customize me-2"></i>
                  <Link to="/status-page-management">Status Page</Link>
                </li>
                <li>
                  <i className="mdi mdi-google-analytics me-2"></i>
                  <Link to="/RCA?tab=RCA">RCA</Link>
                </li>
              </ul>
            </div>
          ) :
          <></>
        }
      </div>
    </React.Fragment>
  );
}

export default SideBar;